import { asType } from '@sparky/framework'
import { ActivationManifest, PrimaryAppIds } from '../renderer'
import { CSP_LEARN_MORE_LINK } from '../constants'

export default asType<ActivationManifest>({
  activation_id: 'profile',
  description: '',
  primary_app_id: PrimaryAppIds.PROFILE,
  flags: {
    hash_required: false,
    cdl_required: false
  },
  activation_screens: [
    {
      key: 'activate',
      component: 'activation.UDefaultActivationScreen',
      props: {
        title: '',
        description: '',
        primaryButton: {
          text: 'Activate Now',
        },
        children: [
          {
            key: 'screen-header',
            component: 'activation.UScreenHeader',
            props: {
              title: 'Activate Subscriptions based on Deployment Profile(s)',
              headerAppId: '',
              hideLicenseInfo: true
            }
          },
          {
            key: 'activation-form',
            component: 'activation.UProfileActivationForm',
            props: {
              title: '',
              subTitle: '',
              children: [
                {
                  key: 'activation-section-csp',
                  component: 'activation.UActivationSection',
                  props: {
                    title: 'Select Customer Support Account',
                    subtitle: 'This account is used for the registration and support of the products and add-ons that are bundled with this subscription.',
                    link: CSP_LEARN_MORE_LINK,
                    children: [
                      {
                        key: 'activation-accordion-csp',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Customer Support Account:',
                          children: [
                            {
                              key: 'default-dropdown-component-csp',
                              component: 'activation.UCSPComponent',
                              props: {
                              },
                            },
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  key: 'activation-section-subscription',
                  component: 'activation.UActivationSection',
                  props: {
                    title: 'Set Up Profile(s)',
                    subtitle: '',
                    children: [
                      {
                        key: 'activation-accordion-tsg',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Recipient:',
                          children: [
                            {
                              key: 'default-tsg-component',
                              component: 'activation.UTSGComponent',
                              props: {
                              }
                            },
                          ]
                        }
                      },
                      {
                        key: 'activation-accordion-region',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Region:',
                          children: [
                            {
                              key: 'default-region-component',
                              component: 'activation.URegionComponent',
                              props: {
                              }
                            },
                          ]
                        }
                      },
                      {
                        key: 'activation-accordion-deployment-profile',
                        component: 'activation.UAccordion',
                        props: {
                          title: '',
                          subtitle: '',
                          hasDoneButton: true,
                          children: [{
                            key: 'deployment-profile-component',
                            component: 'activation.UDeploymentProfiles',
                            props: {
                              title: 'Select Deployment Profile(s):',
                              subtitle: 'The deployment profile(s) shown are based on your customer support account selection.',
                            }
                          }]
                        }
                      },
                      {
                        key: 'activation-accordion-fqdn',
                        component: 'activation.UAccordion',
                        props: {
                          title: 'Subscription URL(s):',
                          children: [{
                            key: 'deployment-profile-sub-domain-fields',
                            component: 'activation.ProfileSubscriptionUrl',
                            props: {
                              title: 'Configure Subscription URL(s):',
                              subtitle: '',
                            }
                          }]
                        }
                      }
                    ]
                  }
                },
                {
                  key: 'form-footer',
                  component: 'activation.FormFooter',
                  props: {
                    group: 3,
                    buttonText: 'Activate',
                    dataTestId: 'activate-button'
                  }
                }
              ]
            }
          },
          {
            key: 'screen-footer',
            component: 'activation.ScreenFooter',
            props: {
            }
          }
        ],
      }
    }
  ],
})
